interface StrategyColorDotProps {
    color: string;
    className?: string;
    size?: 'sm' | 'md';
}

/** Identity swatch for a strategy; always rendered beside the strategy's name so color is never the only cue. */
const StrategyColorDot = ({ color, className = '', size = 'md' }: StrategyColorDotProps) => (
    <span
        aria-hidden="true"
        className={`inline-block flex-none rounded-full ${size === 'sm' ? 'h-1.5 w-1.5' : 'h-2 w-2'} ${className}`}
        style={{ backgroundColor: color }}
    />
);

export default StrategyColorDot;
